var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTiktokBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3095 3.5455C10.622 3.40666 9.99951 3.06414 9.53266 2.56787C9.06582 2.0716 8.77909 1.44752 8.71426 0.786612V0.5H6.34271V9.38564C6.34125 9.77901 6.20926 10.1621 5.9653 10.481C5.72135 10.7999 5.37768 11.0386 4.9826 11.1636C4.58752 11.2886 4.16089 11.2936 3.76265 11.1779C3.36441 11.0622 3.01459 10.8315 2.76234 10.5184L2.76096 10.5178L2.76234 10.5184C2.50617 10.2001 2.36407 9.813 2.35664 9.41327C2.34921 9.01355 2.47683 8.62197 2.72101 8.29534C2.96519 7.96871 3.31322 7.724 3.71464 7.59669C4.11606 7.46939 4.54999 7.4661 4.95352 7.58732V5.31262C4.05368 5.19518 3.13746 5.34622 2.33302 5.7446C1.52857 6.14298 0.876143 6.76878 0.466984 7.53448C0.0578255 8.30017 -0.0875978 9.16745 0.0510554 10.015C0.189709 10.8626 0.605503 11.648 1.24028 12.2615C1.84563 12.8463 2.62182 13.2475 3.46978 13.4139C4.31773 13.5803 5.19898 13.5044 6.00103 13.1958C6.80308 12.8873 7.48955 12.3601 7.97281 11.6816C8.45607 11.003 8.71421 10.2039 8.71426 9.38629V4.84598C9.67268 5.49287 10.8218 5.83973 12 5.83775V3.61309C11.768 3.61336 11.5366 3.59071 11.3095 3.5455Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokBlack);
export default __webpack_public_path__ + "static/media/tiktok-black.ffce5b88c2cd342e4db54c1711b6cdc7.svg";
export { ForwardRef as ReactComponent };